export class Links {
  smpcLink: string;
  publications: Publication[];

  constructor(smpcLink: string, publications: Publication[]) {
    this.smpcLink = smpcLink;
    this.publications = publications;
  }
}

export class Publication {
  id: number;
  name: string;
  link: string;

  constructor(id: number, name: string, link: string) {
    this.id = id;
    this.name = name;
    this.link = link;
  }
}
